import kordanImg from '@/public/images/home/mostVisitedCities/kordan.webp'
import tehranImg from '@/public/images/home/mostVisitedCities/tehran.webp'
import isfahanImg from '@/public/images/home/mostVisitedCities/isfahan.webp'
import ramsarImg from '@/public/images/home/mostVisitedCities/ramsar.webp'
import rashtImg from '@/public/images/home/mostVisitedCities/rasht.webp'
import shirazImg from '@/public/images/home/mostVisitedCities/shiraz.webp'
import mashadImg from '@/public/images/home/mostVisitedCities/mashad.webp'
import masalImg from '@/public/images/home/mostVisitedCities/masal.webp'
import bandaranzaliImg from '@/public/images/home/mostVisitedCities/bandaranzali.webp'
import chalusImg from '@/public/images/home/mostVisitedCities/chalus.webp'
import kashanImg from '@/public/images/home/mostVisitedCities/kashan.webp'
import savadkoohImg from '@/public/images/home/mostVisitedCities/savadkooh.webp'
import karajImg from '@/public/images/home/mostVisitedCities/karaj.webp'
import babolsarImg from '@/public/images/home/mostVisitedCities/babolsar.webp'
import taleshImg from '@/public/images/home/mostVisitedCities/talesh.webp'
import motelghooImg from '@/public/images/home/mostVisitedCities/motelghoo.webp'
import qeshmImg from '@/public/images/home/mostVisitedCities/qeshm.webp'
import kishImg from '@/public/images/home/mostVisitedCities/kish.webp'
import shahriar from '@/public/images/home/mostVisitedCities/shahriar.webp'
// import fouman from '@/public/images/home/mostVisitedCities/fouman.webp'
// import mahmudabadImg from '@/public/images/home/mostVisitedCities/mahmudabad.webp'
// import chabahar from '@/public/images/home/mostVisitedCities/chabahar.webp'

const mostVisitedCities = [
  {
    name: 'تهران',
    absolute_photo_url: tehranImg,
  },
  {
    name: 'کردان',
    absolute_photo_url: kordanImg,
  },
  {
    name: 'رامسر',
    absolute_photo_url: ramsarImg,
  },
  {
    name: 'چالوس',
    absolute_photo_url: chalusImg,
  },
  {
    name: 'ماسال',
    absolute_photo_url: masalImg,
  },
  {
    name: 'رشت',
    absolute_photo_url: rashtImg,
  },
  {
    name: 'بندرانزلی',
    absolute_photo_url: bandaranzaliImg,
  },
  {
    name: 'متل قو',
    absolute_photo_url: motelghooImg,
    hrefName: 'متل قوسلمان شهر',
  },
  {
    name: 'بابلسر',
    absolute_photo_url: babolsarImg,
  },
  {
    name: 'سواد کوه',
    absolute_photo_url: savadkoohImg,
  },
  {
    name: 'تالش',
    absolute_photo_url: taleshImg,
  },
  {
    name: 'کرج',
    absolute_photo_url: karajImg,
  },
  {
    name: 'شهریار',
    absolute_photo_url: shahriar,
  },
  {
    name: 'مشهد',
    absolute_photo_url: mashadImg,
  },
  {
    name: 'اصفهان',
    absolute_photo_url: isfahanImg,
  },
  {
    name: 'شیراز',
    absolute_photo_url: shirazImg,
  },
  {
    name: 'کاشان',
    absolute_photo_url: kashanImg,
  },
  {
    name: 'کیش',
    absolute_photo_url: kishImg,
  },
  {
    name: 'قشم',
    absolute_photo_url: qeshmImg,
  },
  // {
  //   name: 'چابهار',
  //   absolute_photo_url: chabahar,
  // },
  // {
  //   name: 'محمود آباد',
  //   absolute_photo_url: mahmudabadImg,
  // },
  // {
  //   name: 'فومن',
  //   absolute_photo_url: fouman,
  // },
]

export default mostVisitedCities
